import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable()
export class SubmenuService {
  softBack: Subject<any> = new Subject<any>();

  constructor() {}
}
